import React from 'react';
import { Box, Container, Flex, Heading, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { CompassIcon, HandshakeIcon, MoonIcon, LockIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { benefits } from '../data/content';
import { images } from '../data/brand';
const iconMap = {
  compass: CompassIcon,
  handshake: HandshakeIcon,
  moon: MoonIcon,
  lock: LockIcon
};
export function WhyUs() {
  return <Box as="section" id="por-que" position="relative" bg="plum.900" backgroundImage={`url(${images.texture})`} backgroundSize="cover" backgroundPosition="center" py={{
    base: 14,
    md: 24
  }} overflow="hidden" data-id="element-196" data-mp="1gikzzjpcoh0o">
      <Box position="absolute" inset={0} bg="rgba(23,12,32,0.9)" aria-hidden="true" data-id="element-197" data-mp="1lkip2ukfm61j" />
      <Container maxW="76rem" px={{
      base: 4,
      md: 6
    }} position="relative" data-id="element-198" data-mp="3s95eckuxlzek">
        <SectionHeading eyebrow="Nuestra forma de trabajar" title="¿POR QUÉ CONSULTARNOS?" tone="dark" data-id="element-199" data-mp="3nb3u3wlrru1i" />
        <SimpleGrid columns={{
        base: 1,
        sm: 2,
        lg: 4
      }} spacing={{
        base: 4,
        md: 6
      }} mt={{
        base: 10,
        md: 14
      }} data-id="element-200" data-mp="3ec31seg7ncpy">
          {benefits.map(benefit => {
          const IconComponent = iconMap[benefit.icon];
          return <VStack key={benefit.title} align="flex-start" spacing={4} bg="whiteAlpha.50" border="1px solid" borderColor="whiteAlpha.200" borderRadius="xl" p={{
            base: 6,
            md: 7
          }} h="100%" data-id="element-201" data-mp="3s2pzq4e5cykz">
                <Flex align="center" justify="center" w="2.75rem" h="2.75rem" borderRadius="full" border="1px solid" borderColor="gold.400" color="gold.300" data-id="element-202" data-mp="arypwhcra8c2">
                  <IconComponent size={20} aria-hidden="true" data-id="element-203" data-mp="3jxxdno965dp4" />
                </Flex>
                <Heading as="h3" fontSize="xl" color="cream.50" data-id="element-204" data-mp="3k01iq9it0iqz">
                  {benefit.title}
                </Heading>
                <Text fontSize="sm" color="plum.100" data-id="element-205" data-mp="3sydgqwm02itg">
                  {benefit.description}
                </Text>
              </VStack>;
        })}
        </SimpleGrid>
      </Container>
    </Box>;
}